/**
 * Logo do portal HCP (produção).
 * Troque o import abaixo quando houver arte dedicada do HCP.
 */
import hcpLogo from '../brand.webp'

export default hcpLogo
